import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from "@angular/core";
import { TrailerViewModel } from "@app/shared/models/trailers/TrailerViewModel.model";

@Component({
  selector: "app-trailer-license",
  templateUrl: "./trailer-license.component.html",
  styleUrls: ["./trailer-license.component.css"],
})
export class TrailerLicenseComponent implements OnInit, OnChanges {
  @Input() trailer: TrailerViewModel;
  @Input() isEditMode: boolean;
  @Input() states: { abbreviation: string; fullName: string }[];
  @Input() dateInputMask: any;

  @Output() hasChanges = new EventEmitter<boolean>();

  private originalTrailer: string;
  stateOptions: any[] = [];

  constructor() {}

  ngOnInit() {
    this.originalTrailer = JSON.stringify(this.trailer);
    this.initializeStateOptions();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["trailer"] && !changes["trailer"].firstChange) {
      this.originalTrailer = JSON.stringify(this.trailer);
      this.checkForChanges();
    }
    if (changes["states"] && this.states) {
      this.initializeStateOptions();
    }
  }

  initializeStateOptions() {
    if (this.states) {
      this.stateOptions = this.states.map(state => ({
        label: state.fullName,
        value: state.abbreviation
      }));
    }
  }

  onFieldChange() {
    this.checkForChanges();
  }

  onStateChange() {
    this.onFieldChange();
  }

  private checkForChanges() {
    const currentTrailer = JSON.stringify(this.trailer);
    const changed = currentTrailer !== this.originalTrailer;
    this.hasChanges.emit(changed);
  }
}
